import { faLock, faMinus, faPlus, faUnlock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const CourseAccordian = ({ title, id, children , isLocked , isCurated ,buttonStates}) => {
  useEffect(() => {
    if (id === 0) {
      setIsActive(true);
    }
  }, [id]);

  const handleAccordionChange = () => {
    setIsActive(!isActive);
  };

  const [isActive, setIsActive] = useState(false);

  const user_id = useSelector((store) => store?.profileDetails?.id);

  return (
    <div>
      <div
        className={`flex  cursor-pointer items-center justify-between rounded border-2 bg-[#FBFBFB] p-2 font-bold shadow-lg md:flex-row 
     ${
       isActive ? "border-[#F39507]" : ""
     } transition-all duration-200 ease-in-out hover:shadow-xl`}
        onClick={handleAccordionChange}
      >
        <div className="z-100 flex w-full items-center justify-between text-left text-xs md:w-auto md:text-base ">
          <h2 className={`w-auto ${isActive ? "text-[#F39507]" : ""}`}>
            {title}
          </h2>
        </div>
        <div className="relative ml-1 flex  w-full items-center justify-end md:w-auto md:justify-center">
        {buttonStates && <button className="ml-4 cursor-pointer text-black text-center  ">
            <FontAwesomeIcon
              icon={isLocked === true ? faLock : isCurated === false ? faUnlock : ""}
            />
          </button>}
          <button className="ml-4 cursor-pointer  text-center  ">
            <FontAwesomeIcon
              icon={isActive ? faMinus : faPlus}
              className={`${isActive ? "text-[#F1870A]" : ""}`}
            />
          </button>
        </div>
      </div>
      {isActive && (
        <div className=" border-x-2 py-1 shadow-lg md:py-2">{children}</div>
      )}
    </div>
  );
};

export default CourseAccordian;
